import script from "./TableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TableItem.vue?vue&type=script&setup=true&lang=js"

import "./TableItem.vue?vue&type=style&index=0&id=607a943a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-607a943a"]])

export default __exports__